// extracted by mini-css-extract-plugin
export var bandeauAlertContainer = "bandeau-alert-module--bandeau-alert-container--89eb0";
export var bandeauAlertTitle = "bandeau-alert-module--bandeau-alert-title--f3a38";
export var editButton = "bandeau-alert-module--edit-button--009e2";
export var sectionAlert = "bandeau-alert-module--section-alert--a4234";
export var sectionAlertButton = "bandeau-alert-module--section-alert-button--11b2b";
export var sectionAlertContent = "bandeau-alert-module--section-alert-content--1aadb";
export var sectionAlertHeader = "bandeau-alert-module--section-alert-header--655b8";
export var sectionAlertModal = "bandeau-alert-module--section-alert-modal--c722a";
export var sectionAlertTitle = "bandeau-alert-module--section-alert-title--8a143";